/**
 * The goals of a commercial the agency manager sets (the trophies of the
 * « Suivi-Progression » sheet): the calls and the appointments booked a week,
 * the appointments held, the sales and the revenue a month. A period aims at
 * as many weeks or months as it holds; several commercials, at their sum.
 */
export const GOAL_METRICS = [
  { key: 'calls', per: 'week' },
  { key: 'rdvTaken', per: 'week' },
  { key: 'rdvDone', per: 'month' },
  { key: 'sales', per: 'month' },
  { key: 'revenue', per: 'month' },
];

const WEEKS_A_MONTH = 52 / 12;

// The goal of `people` for `key`, a week or a month as the metric counts.
export const goalOfPeople = (goals, people, key) =>
  people.reduce(
    (total, id) =>
      total + (goals.people?.[id]?.[key] ?? goals.defaults?.[key] ?? 0),
    0,
  );

// That goal over a period: a week, a month (52 / 12 weeks), a quarter, or
// days picked freely.
export const goalOverPeriod = (kind, period, value, per) => {
  let weeks = 1;
  if (kind === 'month') weeks = WEEKS_A_MONTH;
  if (kind === 'quarter') weeks = 3 * WEEKS_A_MONTH;
  if (kind === 'custom') weeks = period.days / 7;
  const units = per === 'week' ? weeks : weeks / WEEKS_A_MONTH;
  return value * units;
};

// « 0,5 » under 10 (2 sales a month make half a sale a week), whole above.
export const goalLabel = (value) =>
  value.toLocaleString('fr-FR', { maximumFractionDigits: value < 10 ? 1 : 0 });
